// extracted by mini-css-extract-plugin
module.exports = {"typesWrapper":"iconList_typesWrapper__1Xa10","typesTitles":"iconList_typesTitles__2QbcZ","typesItem":"iconList_typesItem__38fSZ","typesText":"iconList_typesText__eCHI2"};